import { User } from '../types'

export function isUserFirstLogin(user: User): boolean {
  const dateJoinedInMs = new Date(user.date_joined).getTime()
  const lastLoginInMs = new Date(user.last_login).getTime()
  const maxOffset = 1000 * 15 //15sec
  return lastLoginInMs - dateJoinedInMs < maxOffset
}
